import { useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { MARKETPLACE_IS_FREE } from "@/lib/marketplacePolicy";

const ROLE_HOME = {
    admin: "/admin",
    productor: "/productor",
    comprador: "/comprador",
    exportador: "/comprador",
    transportista: "/transportista",
};

export function roleHome(role) {
    return role === "admin" ? "/admin" : "/mi-cuenta";
}

/**
 * RoleGuard blocks access to a page unless the authenticated user has one of
 * the allowed roles. Backend also enforces this (401/403).
 */
export default function RoleGuard({ allow, children }) {
    const { user, loading, sessionExpired } = useAuth();
    const location = useLocation();
    const adminOnly = allow.length === 1 && allow[0] === "admin";
    useEffect(() => {
        // Silent redirect — showing a toast during transient flows (e.g. exiting
        // impersonation) creates confusing UI noise. The visible redirect back
        // to the user's own dashboard is enough feedback.
    }, [loading, user, allow]);

    if (loading) {
        return <div className="container-page py-16 text-center text-muted-foreground">{adminOnly ? "Loading…" : "Cargando…"}</div>;
    }
    if (!user) {
        // Preserve intended destination via `redirect=` so the login flow can return here.
        const target = location.pathname + (location.search || "");
        const expired = sessionExpired ? "&session=expired" : "";
        return <Navigate to={`/ingresar?redirect=${encodeURIComponent(target)}${expired}`} replace />;
    }
    const roles = user.roles?.length ? user.roles : [user.role];
    if (!allow.some((role) => roles.includes(role)) && !(MARKETPLACE_IS_FREE && !adminOnly)) {
        return <Navigate to={roleHome(user.role)} replace />;
    }
    return children;
}
